import React from 'react';
import { DataCard, DataCardProps } from './DataCard';
import './DataCards.scss';

export interface DataCardsProps {
    /** Card theme (bg and fg color) */
    darkTheme: boolean;
    /** Card size. "sm" has different behavior than other sizes. */
    size?: `lg` | `md` | `sm`;
    /** Cards to be rendered. */
    cards: DataCardProps[];
    /** Whether these cards are inside of a component, or standalone on the layout. */
    inline?: boolean;
    /** Name of the customer to be shown above the data cards. */
    customerName?: string;
    embeddedCS?: boolean;
}

export const DataCards = (props: DataCardsProps) => {
    let size: `lg` | `md` | `sm`;
    if (!props.size) {
        size = props?.cards?.length < 4 ? `lg` : `md`;
    } else {
        size = props.size;
    }

    return (
        <section
            className={`data-cards ${
                props.inline ? `no-bg` : `themed-container`
            } ${props.embeddedCS ? `` : `ext-cs`} ${size} ${
                props.darkTheme ? `dark` : `white`
            }`}
        >
            <div className={props.inline ? undefined : `kite-container`}>
                {props.customerName && (
                    <h2>With Spectrum Reach, {props.customerName} achieved:</h2>
                )}
                <ul className={size}>
                    {props?.cards?.map((card, idx) => (
                        <DataCard
                            key={idx}
                            {...card}
                            embeddedCS={props.embeddedCS}
                        />
                    ))}
                </ul>
                {props.inline && (
                    <p className="ext-cs-msg">* See Case Study for Sourcing</p>
                )}
            </div>
        </section>
    );
};
